import { useQuery } from '@tanstack/react-query';
import { getUser } from 'api/userApi';
import { USER_INFO } from '../constants';

type UserInfo = {
  firstName: string;
  lastName: string;
  email: string;
  nextivaUUID: string;
};
interface IUser {
  corporateAccountNumbers: string[];
  firstName: string;
  lastName: string;
  email: string;
  loginId: string;
  nextivaUUID: string;
}

export interface IGetUserInfo {
  user: IUser;
}

export function useGetUserInfo(nextivaUUID: string) {
  const { data, isLoading } = useQuery<IGetUserInfo>([USER_INFO, nextivaUUID], {
    queryFn: () => getUser(null, true, nextivaUUID),
    enabled: !!nextivaUUID,
    onError: (e) => {
      // eslint-disable-next-line no-console
      console.error('Error in getUser', e);
    },
  });

  const userInfo: UserInfo = {
    firstName: data?.user?.firstName || '',
    lastName: data?.user?.lastName || '',
    email: data?.user?.email || '',
    nextivaUUID: data?.user?.nextivaUUID || '',
  };

  return { userInfo, isLoading };
}
